import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export function NumberFormatCustom({ inputRef, onChange, name, suffix = '', ...other }) {
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: name,
            value: values.value
          }
        });
      }}
      placeholder={`0 ${suffix}`}
      isNumericString
      allowNegative={false}
      decimalSeparator={','}
      decimalPrecision={2}
      thousandSeparator={'.'}
      suffix={suffix ? ' ' + suffix : ''}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  suffix: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
